<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <div style="display: inline-block; margin-right: 10px">
          <el-form-item label="型号名称：">
            <el-input v-model.trim="queryForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品类型：">
            <el-select
              v-model="queryForm.productId"
              placeholder="--选择产品类型--"
              filterable
              clearable
              remote
              :remote-method="handleGetProduct"
              @change="handleProductId"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品系列：">
            <el-select
              v-model="queryForm.productModelId"
              filterable
              clearable
              remote
              :remote-method="handleGetProductModel"
              placeholder="--选择系列--"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>

      <!-- 批量上传 -->

      <el-row type="flex" class="row-bg" justify="first">
        <el-form style="width: 200px" class="demo-form-inline forms">
          <el-form-item label="批量上传：">
            <el-upload
              ref="upload"
              class="upload-demo"
              action
              :on-change="handleChange"
              :on-remove="handleRemove"
              :limit="limitUpload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :auto-upload="false"
            >
              <div class="el-upload__text" style="color: #fff">选择文件</div>
              <div slot="tip" class="el-upload__tip">
                只 能 上 传 xlsx / xls 文 件
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-form
          style="
            width: 240px;
            heigth: 36px;
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
          "
        >
          <el-button
            size="medium"
            type="primary"
            @click="up"
            :loading="isLoading"
            >上传</el-button
          >
          <div class="muban">
            <a
              style="color: #fff"
              download="报价模板.xlsx"
              :href="
                'https://ppf-wx.oss-cn-shanghai.aliyuncs.com/%E4%BA%A7%E5%93%81%E6%8A%A5%E4%BB%B7%E6%A8%A1%E6%9D%BF.xlsx?' +
                new Date().getTime()
              "
              >模板下载</a
            >
          </div>
        </el-form>
      </el-row>
    </div>
    <div class="table">
      <div class="content">
        <!-- :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" -->
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column type="expand" fixed="left">
            <template slot-scope="props">
              <el-form
                :key="proIndex"
                v-for="(proItem, proIndex) in props.row.productPosition"
                label-position="left"
                inline
                class="demo-table-expand"
              >
                <el-form-item label="部位编号:">
                  <span>{{ proItem.id }}</span>
                </el-form-item>
                <el-form-item label="产品类型:">
                  <span>{{ proItem.name }}</span>
                </el-form-item>
                <el-form-item label="部位价格:">
                  <span>{{ proItem.price }}</span>
                </el-form-item>
                <el-form-item label="部位属性:">
                  <span>{{ proItem.type }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="id" key="id" label="编号"></el-table-column>
          <el-table-column
            prop="productName"
            key="productName"
            label="产品类型"
          ></el-table-column>
          <el-table-column
            prop="name"
            key="name"
            label="型号名称"
          ></el-table-column>
          <el-table-column
            prop="productModelName"
            key="productModelName"
            label="系列名称"
          ></el-table-column>
          <el-table-column
            prop="warrantyYear"
            key="warrantyYear"
            label="质保年限"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column key="todo" label="操作">
            <template slot-scope="scope">
              <div style="margin-bottom: 10px">
                <span @click="bj(scope.$index, scope.row)" size="small"
                  >编辑</span
                >
                <span @click="sc(scope.$index, scope.row)" size="small"
                  >删除</span
                >
              </div>
              <!-- <span @click="xz(scope.$index,scope.row)" class="btns">下载</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改型号"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item class="ts"
          ><el-form-item label="型号名称：" prop="name">
            <el-input
              v-model.trim="editForm.name"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="质保年限：" prop="warrantyYear">
            <el-input
              v-model.trim="editForm.warrantyYear"
              auto-complete="off"
            ></el-input> </el-form-item
        ></el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品类型：" prop="productId">
            <el-select
              disabled
              @change="handleProductId"
              v-model="editForm.productId"
              placeholder="--选择产品类型--"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品系列：" prop="productModelId">
            <el-select
              filterable
              clearable
              remote
              :remote-method="handleGetProductModel"
              v-model="editForm.productModelId"
              placeholder="--选择产品系列--"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <div style="margin: 30px" v-if="editForm.productPosition.length !== 0">
          部位价格
        </div>
        <el-form-item
          :label="position.name"
          v-for="(position, poIndex) in editForm.productPosition"
          :key="poIndex"
          required
        >
          <el-input
            @input="changeSetInput"
            v-model.trim="position.price"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="editAddDomain">新增质保部位</el-button> -->
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加型号"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item class="ts">
          <el-form-item label="型号名称：" prop="name">
            <el-input
              v-model.trim="newForm.name"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="质保年限：" prop="warrantyYear">
            <el-input
              v-model.trim="newForm.warrantyYear"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item label="产品类型：" prop="productId">
            <el-select
              filterable
              clearable
              remote
              :remote-method="handleGetProduct"
              @change="handleProductId"
              v-model="newForm.productId"
              placeholder="--选择产品类型--"
            >
              <el-option
                v-for="item in productIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品系列：" prop="productModelId">
            <el-select
              v-model="newForm.productModelId"
              placeholder="--选择产品系列--"
              filterable
              clearable
              remote
              :remote-method="handleGetProductModel"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <div
          style="margin: 30px"
          v-if="
            newForm.productPosition
              ? newForm.productPosition.length !== 0
              : false
          "
        >
          部位价格
        </div>
        <el-form-item
          :label="position.name"
          v-for="(position, poIndex) in newForm.productPosition"
          :key="poIndex"
          required
        >
          <el-input
            style="width: 80%"
            v-model.trim="position.price"
            auto-complete="off"
            @input="changeSetInput"
          ></el-input>
          <el-button @click.prevent="removeQualityParts(poIndex)"
            >删除</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getZBCP, getCP, getCPLX, getCPJM } from "./../axios/api";
import moment from "dayjs";
export default {
  name: "Zbcp",
  data() {
    return {
      isLoading: false, // 上传
      limitUpload: 1, // 限制上传数量
      productIdList: [], // 产品类型
      proModelList: [], // 产品系列
      queryForm: {},
      editFormVisible: false, //编辑弹框
      editForm: {
        productModelId: null,
        productPosition: [],
      }, //编辑弹框数据
      newData: false, //添加弹框
      newForm: {
        productModelId: null,
        productPosition: [],
      }, //添加弹框数据
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      rules: {
        name: [{ required: true, message: "请输入型号", trigger: "blur" }],
        productId: [
          { required: true, message: "请输选择产品类型", trigger: "change" },
        ],
        productModelId: [
          { required: true, message: "请输选择系列", trigger: "change" },
        ],
        warrantyYear: [
          { required: true, message: "请输入质保年限", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 删除部位
    removeQualityParts(index) {
      this.newForm.productPosition.splice(index, 1);
      // this.$forceUpdate();
    },
    // 解决input输入框无法输入的情况
    changeSetInput() {
      this.$forceUpdate();
    },
    // 获取产品类型
    handleGetProduct(query) {
      let that = this;
      getCPLX
        .getTable({
          pageNumber: 1,
          pageSize: 1000,
          name: query || undefined,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            that.productIdList = list;
          }
        });

      that.handleGetProductModel();
    },

    // 获取系列
    handleGetProductModel(query) {
      let that = this;

      getCPJM
        .getWFTable({
          pageSize: 1000,
          pageNumber: 1,
          name: query || undefined,
          productId:
            that.newForm.productId ||
            that.editForm.productId ||
            that.queryForm.productId ||
            undefined,
        })
        .then(function (res) {
          // console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            // console.log(list);

            that.proModelList = list;
          }
        });
    },
    // 选择产品类型时
    handleProductId(value) {
      let that = this;
      // console.log(value);

      that.productIdList.map((pro) => {
        if (pro.id === value) {
          // console.log(pro.position);
          pro.position.map((pos) => {
            pos.price = null;
          });
          that.newForm.productPosition = pro.position;
          that.editForm.productPosition = pro.position;
          // console.log(pro.position);
        }
      });

      //获取系列列表
      that.handleGetProductModel();
    },

    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },

    up: function () {
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          this.isLoading = true;
          this.$message({
            type: "warning",
            message: "正在上传",
          });
          this.importfxx(this.fileTemp);
          this.fileTemp = null;
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！",
        });
      }
    },

    importfxx(obj) {
      let that = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          // console.log(outdata);

          outdata.map(function (item) {
            item.id = item.编号 ? item.编号 : "";

            item.productId = item.产品类型 ? item.产品类型 : "";
            item.productModelId = item.系列 ? item.系列 : "";
            item.name = item.型号 ? item.型号.toString() : "";
            item.warrantyYear = item.质保年限 ? item.质保年限 : "";

            item.productPosition = [];
            let productPositionObj = {};
            productPositionObj.type = item.部位 ? item.部位 : "";
            that.productIdList.map((pro) => {
              if (pro.id === item.productId) {
                pro.position.map((pos) => {
                  if (productPositionObj.type === pos.type) {
                    productPositionObj.name = pos.name;
                    productPositionObj.price = item.价格 ? item.价格 : "";
                    productPositionObj.price = parseFloat(
                      (productPositionObj.price * 100).toFixed(2)
                    );

                    item.productPosition.push(productPositionObj);
                  }
                });
              }
            });

            delete item.编号;
            delete item.productId;
            delete item.产品类型;
            delete item.系列;
            delete item.部位;
            delete item.价格;
            delete item.型号;
            delete item.质保年限;
            delete item.备注;
          });
          // console.log(outdata);
          // console.log(JSON.stringify(outdata));

          // 处理上传数据
          //debugger;
          let keyInx = {};
          for (var i = 0; i < outdata.length; i++) {
            var id = outdata[i].id;
            // console.log(i);
            if (keyInx[id] >= 0) {
              var product1 = outdata[i].productPosition;
              var product2 = outdata[keyInx[id]].productPosition;
              outdata[keyInx[id]].productPosition = product1.concat(product2);
              outdata.splice(i, 1);
              i--;
            } else {
              keyInx[id] = i;
            }

            delete outdata[i].id;
          }

          console.log(outdata);

          // 调用上传接口
          that.batchNewUpdate(outdata);
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },

    batchNewUpdate: function (batchData) {
      var that = this;
      Promise.all(batchData.map((d) => getCP.addTable(JSON.stringify(d))))
        .then(function (res) {
          console.log(res);
          res.map((r) => {
            if (r.code !== 0) {
              that.$alert(r.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            } else {
              that.$message.success("上传成功！");
              that.isLoading = false;
              that.init();
            }
          });
        })
        .catch(function (res) {});
    },

    //搜索
    search: function () {
      var that = this;
      that.loading = true;
      that.currentPage = 1;
      that.init();
    },
    reset: function () {
      this.queryForm = {};
      this.currentPage = 1;
      this.init();
    },

    add: function () {
      this.newData = true; //显示弹框

      this.handleGetProduct();
    },
    //点击关闭dialog
    newClose(done) {
      let that = this;
      that.newData = false;

      that.$refs["newForm"].resetFields();
      // that.newForm.productPosition = [];
      that.newForm = {};

      that.handleGetProduct();
    },
    //点击取消
    newCancel(formName) {
      let that = this;
      that.newData = false;
      that.newForm = {};
      that.$refs["newForm"].resetFields();
      // that.newForm.productPosition = [];

      that.handleGetProduct();
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          // console.log(that.newForm.productPosition);
          that.newForm.productPosition.map((pro) => {
            pro.price = parseFloat((pro.price * 100).toFixed(2));
            delete pro.ratio;
          });

          if (
            that.newForm.productPosition.length === 0 ||
            JSON.stringify(that.newForm.productPosition).indexOf("null") != -1
          ) {
            that.$message.error("请添加部位价格!");
          } else {
            let data = {
              name: that.newForm.name,
              warrantyYear: Number(that.newForm.warrantyYear),
              productModelId: that.newForm.productModelId,
              productPosition: that.newForm.productPosition,
            };
            console.log(data);
            // return;
            //这里再向后台发个post请求重新渲染表格数据
            getCP
              .addTable(JSON.stringify(data))
              .then(function (res) {
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message({
                    type: "success",
                    message: "添加成功!",
                  });
                  that.$refs["newForm"].clearValidate();
                  that.newForm = {};

                  that.newData = false;
                  // that.currentPage = 1;
                  that.init();
                }
              })
              .catch(function (res) {
                //清空
                that.$refs["newForm"].clearValidate();
                that.newForm = {};

                that.newData = false;
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    current_change: function (currentPage) {
      // console.log(currentPage)
      var that = this;
      this.currentPage = currentPage;
      this.init();
    },
    //点击编辑
    bj: function (index, row) {
      console.log(row);
      var that = this;
      this.editFormVisible = true; //显示弹框

      that.editForm = row; // editForm是Dialog弹框的data

      that.productIdList[
        {
          id: row.productId,
          name: row.productName,
        }
      ];

      that.handleGetProductModel();
      // that.editForm
    },

    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      // this.editForm = {};

      this.init();
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      // this.editForm = {};

      this.init();
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          //更新的时候就把弹出来的表单中的数据写到要修改的表格中
          // console.log(that.editForm.productPosition);
          that.editForm.productPosition.map((pro) => {
            pro.price = parseFloat((pro.price * 100).toFixed(2));
            delete pro.createdAt;
            delete pro.productTypeId;
            delete pro.status;
            delete pro.updatedAt;
            delete pro.ratio;
          });
          if (
            that.editForm.productPosition.length === 0 ||
            JSON.stringify(that.editForm.productPosition).indexOf("null") != -1
          ) {
            that.$message.error("请添加部位价格!");
          } else {
            let data = {
              name: that.editForm.name,
              warrantyYear: Number(that.editForm.warrantyYear),
              productModelId: that.editForm.productModelId,
              productPosition: that.editForm.productPosition,
            };
            console.log(data);
            // return;
            getCP
              .editTable(data, that.editForm.id)
              .then(function (res) {
                if (res.code !== 0) {
                  that.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message({
                    type: "success",
                    message: "更新成功!",
                  });
                  that.editFormVisible = false;
                  that.$refs["editForm"].resetFields();
                  that.init();
                }
              })
              .catch(function (res) {
                that.editFormVisible = false;
                // console.log(res)
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //点击删除
    sc: function (index, row) {
      var that = this;
      // console.log(row)
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getCP
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
              // that.currentPage = 1;
              that.init();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    init: function () {
      var that = this;
      that.loading = true;
      let data = {
        productId: that.queryForm.productId
          ? that.queryForm.productId
          : undefined,
        productModelId: that.queryForm.productModelId
          ? that.queryForm.productModelId
          : undefined,
        name: that.queryForm.name ? that.queryForm.name : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };

      // return
      getCP.getTable(data).then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            lis.productPosition.map((pro) => {
              pro.price = parseFloat((pro.price / 100).toFixed(2));
            });
          });

          // console.log(list)
          that.total = totalNumber;
          that.tableData = list;
          that.loading = false;
        }
      });

      that.handleGetProduct(); // 获取产品类型等
    },
  },
  mounted() {
    var that = this;
    that.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.demo-table-expand {
  font-size: 0;
  margin-left: 20px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 40px;
  /* margin-right: 0;
  margin-bottom: 0; */
  /* width: 50%; */
}
</style>



// WEBPACK FOOTER //
// src/page/Bjgl.vue